import React, { FC, useEffect } from "react";

import { State } from "../../../enums";
import { NotAllowedButtonAudio } from "../../NotAllowedButton/NotAllowedButtonAudio";
import { AudioPlayerPreviewButton } from "../AudioPlayerPreviewButton";

interface Props {
  setPlayerApiSimple: () => void;
  state: State;
}

export const NonPlayableAudio: FC<Props> = ({ setPlayerApiSimple, state }) => {
  useEffect(() => {
    setPlayerApiSimple();
  }, [setPlayerApiSimple]);

  if (state === State.NOT_ALLOWED_CHANNEL || state === State.NOT_ALLOWED) {
    return <NotAllowedButtonAudio />;
  }

  return <AudioPlayerPreviewButton state={state} />;
};
